import { render, staticRenderFns } from "./ActasConcejo.vue?vue&type=template&id=06574868&scoped=true&"
import script from "./ActasConcejo.vue?vue&type=script&lang=ts&"
export * from "./ActasConcejo.vue?vue&type=script&lang=ts&"
import style0 from "./ActasConcejo.vue?vue&type=style&index=0&id=06574868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06574868",
  null
  
)

export default component.exports